import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";

const CTASection = ({
  title = "Let's build something that clicks.",
  text = "Tell us where your business is — and where you want it to go. We'll map the digital route.",
  dark = true,
}) => (
  <section data-testid="cta-section" className={`relative ${dark ? "bg-navy" : "bg-mist"} grain overflow-hidden`}>
    <div className="absolute inset-0 dot-grid opacity-40" aria-hidden="true" />
    <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[600px] h-[400px] bg-brand/20 blur-[140px] rounded-full" aria-hidden="true" />
    <div className="relative max-w-8xl mx-auto px-6 lg:px-12 py-24 lg:py-36">
      <Reveal>
        <h2 className={`font-display font-extrabold tracking-tighter leading-[1.02] text-4xl md:text-6xl lg:text-7xl max-w-4xl ${dark ? "text-mist" : "text-navy"}`}>
          {title}
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <p className={`mt-6 text-base md:text-lg max-w-xl ${dark ? "text-slatec" : "text-navy/70"}`}>{text}</p>
      </Reveal>
      <Reveal delay={0.18}>
        <div className="mt-10 flex flex-wrap gap-4">
          <Link
            to="/contact"
            data-testid="cta-primary-button"
            className="inline-flex items-center gap-2 bg-brand hover:bg-electric hover:text-navy-deep text-white font-semibold px-8 py-4 rounded-full transition-colors duration-300"
          >
            Let's Grow Your Brand
            <ArrowUpRight size={18} />
          </Link>
          <a
            href="tel:+917307958742"
            data-testid="cta-call-button"
            className={`inline-flex items-center gap-2 border font-semibold px-8 py-4 rounded-full transition-colors duration-300 ${
              dark
                ? "border-white/20 text-mist hover:border-electric hover:text-electric"
                : "border-navy/20 text-navy hover:border-brand hover:text-brand"
            }`}
          >
            Call +91 73079 58742
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CTASection;
